import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import { AleWidget } from './features/ale-bot';

// Pages
import PlansWizard from './pages/PlansWizard';
import AdminLogin from './pages/AdminLogin';
import AdminCupons from './pages/AdminCupons';
import ConfirmacaoCadastro from './pages/ConfirmacaoCadastro';

// Styles
import 'react-toastify/dist/ReactToastify.css';

// Configuração do React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

// Layout principal da aplicação
const AppLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main style={{ minHeight: 'calc(100vh - 140px)' }}>
        {children}
      </main>
      <Footer />
      {/* Assistente virtual "Ale" — apenas nas telas públicas (não no admin) */}
      <AleWidget />
    </>
  );
};

// Layout administrativo (sem header/footer)
const AdminLayout = ({ children }) => {
  return children;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            {/* Rotas públicas com layout principal */}
            <Route path="/" element={<AppLayout><PlansWizard /></AppLayout>} />
            <Route path="/plans" element={<AppLayout><PlansWizard /></AppLayout>} />

            {/* Rota de confirmação de cadastro (sem layout - página standalone) */}
            <Route path="/confirmar/:token" element={<ConfirmacaoCadastro />} />

            {/* Rotas administrativas (sem header/footer) */}
            <Route path="/admin/login" element={<AdminLayout><AdminLogin /></AdminLayout>} />
            <Route path="/admin" element={<AdminLayout><AdminCupons /></AdminLayout>} />
            <Route path="/admin/cupons" element={<AdminLayout><AdminCupons /></AdminLayout>} />
            <Route path="/admin/vendedores" element={<AdminLayout><AdminCupons /></AdminLayout>} />
            <Route path="/admin/vendas" element={<AdminLayout><AdminCupons /></AdminLayout>} />
            <Route path="/admin/relatorios" element={<AdminLayout><AdminCupons /></AdminLayout>} />

            {/* Rota 404 - Redireciona para plans */}
            <Route path="*" element={<AppLayout><PlansWizard /></AppLayout>} />
          </Routes>
        </Router>

        {/* Toast notifications */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;


